/*
 * updated 3.nov 2020
 */
export const UserModel = {
    id: 0, // int or string ??
    username: "", // string
    name: "", // string
    address: "", // string
    address2: "", // string
    zip: "", // string
    city: "", // string
    email: "", // string
    secondaryEmail: "", // string
    mobile: "", // string
    createdOn: "", // date
    updatedOn: "", // date
    createdBy: "", // string
    updatedBy: "", // string
    note: "", // string
    country: "", // string
    displayName: "", // string
    primaryRole: 0, // number
    isActive: false, // boolean
    isApproved: false,
    isAdmin: false,
};

/*
 * updated 4.nov 2020
 */
export const CompanyModel = {
    cvr: "", // string
    name: "", // string
    ean: "", // string
};

export const PspModel = {
    pspElement: "", //"string",
    responsible: "", //"string"
};
